module.exports = __webpack_public_path__ + "static/fonts/FuturaBT.ee64fb9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/FuturaBT.ttf
// module id = 863
// module chunks = 117